import { formatGooglePlaceData } from "kinnect-formatters";
import { gmapApi } from "vue2-google-maps";

export default {
	name: "GeocodableMixin",

	data: () => ( {
		geocodedLocation: null,
		geocoder: null,
		numGeocodersRunning: 0,
		placeIdToGeocode: null,
		geocodeCache: {}
	} ),

	computed: {
		google: gmapApi,

		kinnunenLatLng() {
			return new this.google.maps.LatLng(
				36.115717,
				-97.0498469
			);
		},

		geocoderRunning() {
			return this.numGeocodersRunning !== 0;
		},

		geocodeParams() {
			if ( this.placeIdToGeocode ) {
				return { placeId: this.placeIdToGeocode };
			}

			return { location: this.innerLocationToGeocode };
		},

		locationToGeocodeLat() {
			if ( this.locationToGeocode && this.locationToGeocode.lat ) {
				if ( this.locationToGeocode instanceof this.google.maps.LatLng ) {
					return this.locationToGeocode.lat();
				}

				return this.locationToGeocode.lat;
			}
		},

		locationToGeocodeLng() {
			if ( this.locationToGeocode && this.locationToGeocode.lng ) {
				if ( this.locationToGeocode instanceof this.google.maps.LatLng ) {
					return this.locationToGeocode.lng();
				}

				return this.locationToGeocode.lng;
			}
		},

		innerLocationToGeocode() {
			if ( this.locationToGeocodeLat && this.locationToGeocodeLng ) {
				return {
					lat: this.locationToGeocodeLat,
					lng: this.locationToGeocodeLng
				};
			}
		},

		distanceFromKinnunen() {
			const meters = this.google.maps.geometry.spherical.computeDistanceBetween(
				new this.google.maps.LatLng(
					this.locationToGeocodeLat,
					this.locationToGeocodeLng
				),
				this.kinnunenLatLng
			);
			const miles = meters * 0.00062137;

			return Math.round( miles );
		}
	},

	methods: {
		addGeocoder() {
			this.numGeocodersRunning += 1;
		},

		subtractGeocoder() {
			this.numGeocodersRunning = Math.max( this.numGeocodersRunning - 1, 0 );
		},

		geocode() {
			this.$gmapApiPromiseLazy().then( () => {
				if ( !this.geocoder ) {
					this.geocoder = new this.google.maps.Geocoder();
				}

				const geocodeCacheKey = `${this.innerLocationToGeocode.lat},
				${this.innerLocationToGeocode.lng}`;

				if ( this.geocodeCache.hasOwnProperty( geocodeCacheKey ) ) {
					return this.$set( this, "geocodedLocation", this.geocodeCache[geocodeCacheKey] );
				}

				const positionAtRequestStart = this.innerLocationToGeocode;

				this.addGeocoder();

				this.geocoder.geocode( this.geocodeParams, ( places, status ) => {
					if ( status === this.google.maps.GeocoderStatus.OK
						&& positionAtRequestStart.lat === this.innerLocationToGeocode.lat
						&& positionAtRequestStart.lng === this.innerLocationToGeocode.lng
					) {
						const placeData = places[0] ? formatGooglePlaceData( places[0] ) : null;

						if ( placeData ) {
							this.$set( this.geocodeCache, geocodeCacheKey, placeData );
							this.$set( this, "geocodedLocation", placeData );
						}
					} else if ( status === this.google.maps.GeocoderStatus.OVER_QUERY_LIMIT
						|| status === this.google.maps.GeocoderStatus.UNKNOWN_ERROR
						|| status === this.google.maps.GeocoderStatus.ERROR
					) {
						return setTimeout( () => {
							this.subtractGeocoder();
							this.geocode();
						}, 2000 );
					}

					this.subtractGeocoder();
				} );
			} );
		}
	}
};
